/**
 * スクリーニング チャート表示制御
 */
import $ from 'jquery';
import StockIndexChart from './stock_index_chart.js';

// 描画したチャートのクラスオブジェクトを保存するリスト
const chartClasses = [];

// 初期表示
$(function () {
    // チャートタブ以外はデータがないので処理しない
    if ($('#jsonScreeningResult').length == 0) {
        return;
    }

    // チャートの表示レンジ操作無効化
    $('.range_select select').prop('disabled', true);

    let screeningResults = JSON.parse($('#jsonScreeningResult').val());

    // 銘柄分のチャートを取得
    $.each(screeningResults, function (idx, result) {
        let stockCd = result['STOCK_CD'],
            ChartClass = new StockIndexChart(stockCd),
            // 初期表示期間ID
            defaultPeriodId = 2;

        ChartClass.initChart(defaultPeriodId);
        chartClasses.push(ChartClass);
    });

    // チャートの表示レンジ操作無効化解除
    $('.range_select select').prop('', false);
});

// チャートの表示レンジを変更
$(document).on('change', '.legend_list input[name=chart_range]:radio', function () {

    chartClasses.forEach(instance => {
        instance.setChartRange($(this).val());
    });
});
